import type { MessageTemplate } from '@racemap/sdk/schema/messageTemplates';
import type { TRACKER_TYPES } from '@racemap/sdk/schema/trackers';
import { Form, type FormInstance } from 'antd';
import type { Immutable } from 'immer';
import type { FC } from 'react';
import type { FormValues } from './AddTrackerCommando';
import { TrackerCommandArgumentsForm } from './TrackerCommandArgumentsForm';

interface Props {
  template: Immutable<MessageTemplate>;
  form: FormInstance<FormValues>;
  relevantTrackerTypes: Array<TRACKER_TYPES>;
}

export const TrackerCommandForm: FC<Props> = ({ template, form, relevantTrackerTypes }) => {
  return (
    <div>
      <Form.Item label="Description">{template.description}</Form.Item>
      <TrackerCommandArgumentsForm
        templateArguments={template.arguments}
        form={form}
        relevantTrackerTypes={relevantTrackerTypes}
      />
    </div>
  );
};
